import { combineReducers } from 'redux';

import * as types from 'modules/selfServices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  kioskAdminToken: null | string,
 * }} DataState
 */

export default combineReducers({
  kioskAdminToken: createReducer(null, {
    [types.GET_KIOSK_ADMIN_TOKEN]: () => null,
    [types.GET_KIOSK_ADMIN_TOKEN_FAILURE]: () => null,
    [types.GET_KIOSK_ADMIN_TOKEN_SUCCESS]: (_, { payload }) => payload.token,
  }),
});
